exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tabbarHeaderInner .el-tabs__header {\n  margin: 0 !important;\n}\n.tabbarHeaderInner .el-tabs__header .el-tabs__nav-wrap:after {\n  height: 1px !important;\n  background-color: #f0f0f0 !important;\n}\n.tabbarHeaderInner .el-tabs__header .el-tabs__nav-wrap .el-tabs__active-bar {\n  background-color: #333 !important;\n  height: 1px !important;\n}\n.tabbarHeaderInner .el-tabs__header .el-tabs__nav-wrap .is-active .iconStyle {\n  color: #333 !important;\n}\n.tabbarHeaderInner .el-tabs__header .el-tabs__nav-wrap .is-active .countText {\n  color: #333 !important;\n}\n", ""]);

// exports
